<div class="tailor-intake">

  <!-- Group 1: Wie en waarvoor -->
  <div class="intake-group">
    <h6 class="group-heading">{{ 'cv.tailor.intake.groupWho' | translate }}</h6>

    <!-- Subject consultant (read-only; fixed by the launching context) -->
    <p class="subject-line">
      {{ 'cv.tailor.intake.subjectLabel' | translate }}
      <strong>{{ subjectName || ('cv.tailor.intake.unknownConsultant' | translate) }}</strong>
    </p>

    <div class="control-row">
      <label class="control-label">{{ 'cv.tailor.intake.template' | translate }}</label>
      <nb-select
        fullWidth
        [selected]="selectedPickerValue"
        (selectedChange)="onTemplatePickerChange($event)"
        [placeholder]="'cv.tailor.intake.templatePlaceholder' | translate">
        <nb-option-group [title]="'cv.generate.builtInGroup' | translate">
          @for (tpl of templates; track tpl.id) {
            <nb-option [value]="'built_in:' + tpl.id">{{ tpl.name }}</nb-option>
          }
        </nb-option-group>
        @if (brandedTemplates.length > 0) {
          <nb-option-group [title]="'cv.generate.brandedGroup' | translate">
            @for (tpl of brandedTemplates; track tpl.id) {
              <nb-option [value]="'client:' + tpl.id">{{ tpl.name }} ({{ tpl.base_layout_id }})</nb-option>
            }
          </nb-option-group>
        }
      </nb-select>
    </div>

    <div class="control-row">
      <label class="control-label">{{ 'cv.tailor.intake.localeField' | translate }}</label>
      <nb-select
        fullWidth
        [formControl]="$any(form.get('locale'))"
        [placeholder]="'cv.tailor.intake.localePlaceholder' | translate">
        <nb-option value="nl">Nederlands</nb-option>
        <nb-option value="en">English</nb-option>
      </nb-select>
    </div>
  </div>

  <!-- Group 2: Aanpak -->
  <div class="intake-group intake-group-last">
    <h6 class="group-heading">{{ 'cv.tailor.intake.groupApproach' | translate }}</h6>

    <!-- Beschikbaarheid -->
    <div class="control-row">
      <label class="control-label" for="intake-availability">
        {{ 'cv.tailor.intake.availability' | translate }}
      </label>
      <input
        id="intake-availability"
        nbInput
        fullWidth
        type="text"
        [formControl]="$any(form.get('availability'))"
        [placeholder]="'cv.tailor.intake.availabilityPlaceholder' | translate">
    </div>

    <!-- Claim strength -->
    <div class="control-row">
      <label class="control-label">
        <span class="hint-tip" tabindex="0" [nbTooltip]="'cv.tailor.intake.claimHint' | translate" [attr.aria-description]="'cv.tailor.intake.claimHint' | translate">{{ 'cv.tailor.intake.claimStrength' | translate }}</span>
      </label>
      <nb-select
        fullWidth
        [formControl]="$any(form.get('claim_strength'))"
        [placeholder]="'cv.tailor.intake.claimPlaceholder' | translate">
        @for (opt of claimOptions; track opt.value) {
          <nb-option [value]="opt.value">{{ opt.label | translate }}</nb-option>
        }
      </nb-select>
    </div>

    <!-- Salutation (cover letter) -->
    <div class="control-row">
      <label class="control-label" for="intake-salutation">
        {{ 'cv.tailor.intake.salutation' | translate }}
      </label>
      <input
        id="intake-salutation"
        nbInput
        fullWidth
        type="text"
        [formControl]="$any(form.get('salutation'))"
        [placeholder]="'cv.tailor.intake.salutationPlaceholder' | translate">
    </div>
  </div>

  <!-- Footer actions -->
  <div class="intake-actions">
    <button
      nbButton
      status="basic"
      type="button"
      (click)="onCancel()">
      {{ 'cv.tailor.intake.cancel' | translate }}
    </button>
    <button
      nbButton
      status="primary"
      type="button"
      [disabled]="!canSubmit"
      [nbSpinner]="submitting || busy"
      nbSpinnerStatus="basic"
      (click)="onSubmit()">
      {{ 'cv.tailor.settings.regenerate' | translate }}
    </button>
  </div>

</div>
